import { defineMessages } from 'react-intl';

const messages = defineMessages({
  styling: {
    id: 'Styling',
    defaultMessage: 'Styling',
  },
  Type: {
    id: 'Listing',
    defaultMessage: 'Listing',
  },
  Theme: {
    id: 'Theme',
    defaultMessage: 'Theme',
  },
  ThemeHelp: {
    id: 'Theme',
    defaultMessage: 'Theme',
  },
  ThemeDefault: {
    id: 'Default',
    defaultMessage: 'Default',
  },
  ThemePrimary: {
    id: 'Primary',
    defaultMessage: 'Primary',
  },
  ThemeSecondary: {
    id: 'Secondary',
    defaultMessage: 'Secondary',
  },
  ThemeTertiary: {
    id: 'Tertiary',
    defaultMessage: 'Tertiary',
  },
  Rounded: {
    id: 'Rounded',
    defaultMessage: 'Rounded',
  },
  RoundedHelp: {
    id: 'Rounded Image',
    defaultMessage: 'Rounded Image',
  },
  Inverted: {
    id: 'Inverted',
    defaultMessage: 'Inverted',
  },
  InvertedHelp: {
    id: 'InvertedHelp',
    defaultMessage: 'Inverted theme',
  },
  Bordered: {
    id: 'Bordered',
    defaultMessage: 'Bordered',
  },
  ObjectFit: {
    id: 'Object fit',
    defaultMessage: 'Object fit',
  },
  ObjectFitHelp: {
    id: 'ObjectFitHelp',
    defaultMessage: 'Css property object-fit applied on Card image',
  },
  ObjectPosition: {
    id: 'ObjectPosition',
    defaultMessage: 'Object position',
  },
  ObjectPositionHelp: {
    id: 'ObjectPositionHelp',
    defaultMessage: 'Css property object-position applied on Card image',
  },
});

export default messages;
